const categories = [
  {
    title: "Humanoids",
    image: "storage/273dd89969b0ca02ea0fef7343486235/unitreeHumanoid-.webp",
    handle: "unitree-humanoid",
  },
  // {
  //   title: "Underwater Series",
  //   image: "storage/dec37ed88ca77e7e8fbd3518a1009643/Underwater%20Drone.png",
  //   handle: "underwater-series",
  // },
  {
    title: "Companions Robots",
    image: "storage/4202735b6fbde1f90dc9c934c2c2efa9/Companion.webp",
    handle: "companion-robots",
  },
  {
    title: "Industrial Robots",
    image: "storage/31aafb258afe6089dad9d69bc54b89f4/Industrial-Robots.png",
    handle: "industrial-robots",
  },
  // {
  //   title: "Anti-Drone system",
  //   image: "storage/5e1c0b0a22b827432898214e3a94a0b0/Anti-Drone-Systems.webp",
  //   handle: "anti-drone",
  // },
  {
    title: "Handheld",
    image: "storage/9fe902b257c6bf2fe9ee4782f75bc3bd/Web-images--4.png",
    handle: "handheld",
  },
  {
    title: "Insta360",
    image: "storage/408cfb603448386e6cd08e989f1294aa/Insta360.webp",
    handle: "insta360",
  },
  {
    title: "Mobiles",
    image: "storage/97d51d5237977866e036239bc490ed7c/Mobiles.webp",
    handle: "mobiles",
  },
  {
    title: "Laptops",
    image: "storage/fa537b7e732b96bb5c660ca99e6ef2da/Laptops.webp",
    handle: "laptops",
  },
  {
    title: "Remote Controllers",
    image: "storage/c97e5ce5b0a85ea4c4abbe1e9e791bad/Remote-Controllers.webp",
    handle: "remote-controllers",
  },
  {
    title: "Accessories",
    image:
      "storage/49530dfa7cc65d3387fc098b309785de/Charger%20charging%20hub%20propellor.png",
    handle: "accessories",
  },
];

export default categories;
